import { render, staticRenderFns } from "./OrderExportPDF.vue?vue&type=template&id=1bb6b174&"
import script from "./OrderExportPDF.vue?vue&type=script&lang=js&"
export * from "./OrderExportPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports